module.exports = {
	"next": "次へ",
	"skip": "Cozy 作成へジャンプ",
	"cancel": "キャンセル",
	"back": "戻る",
	"sign up": "登録",
	"add email": "メールアカウントを追加",
	"welcome": "入りたい!",
	"confirm": "確認",
	"user missing properties": "申し訳ありません。このユーザーは存在しません。",
	"step welcome user": "%{name} さん、ようこそ!",
	"step welcome anon": "ようこそ!",
	"step welcome logout": "%{name} さんではありませんか?",
	"step welcome congrats": "おめでとうございます。おかげさまで、あなたの個人データは、Cozy の安全な場所にあります。",
	"step welcome next": "次へ",
	"step agreement title": "利用規約",
	"step agreement subtitle": "Cosy にアクセスするには、利用規約を読み、同意する必要があります。 どんな人でも、そうしたくないと思います。 ここでは、私たちがあなたのために作った短いバージョンを紹介します:",
	"step agreement element 0": "自宅で管理を行い、データに責任を持ってください!",
	"step agreement element 1": "あなたの Cozy のお手伝いをします...",
	"step agreement element 2": "...Cozy やあなたのデータが間違っていない限り",
	"step agreement element 3": "データを使用するサービスを選択して、目標を理解します",
	"step agreement element 4": "誰も (私たちでさえ) Cozy であなたのデータにアクセスすることはできません",
	"step agreement element 5": "法的事項やサービス品質に関してのみ、あなたに対していくつかの詳細があります",
	"step agreement stats": "Cozy が匿名でデータを収集することを許可します",
	"step agreement description 1": "完全な利用規約にアクセスすることができます",
	"step agreement description 2": "\"同意する\" ボタンをクリックすることにより、これらの条件を読み、理解し、同意することを受け入れるたことになります。",
	"step agreement description link": "ここ。",
	"step agreement next": "同意する",
	"step preset": "設定",
	"step import": "データのインポート",
	"step email settings": "メールの構成",
	"preset email": "メール",
	"preset email tip": "あなたがパスワードを紛失した場合に連絡するために使用されます。",
	"preset name": "名前",
	"step password empty": "パスワードの値が不足しています。",
	"step password too weak": "パスワードの安全度が低すぎます。大文字、数字、特殊文字を追加したり、より長いパスワードにする必要があります。",
	"step password title": "パスワードを保護してください",
	"step password label": "パスワード",
	"step password input placeholder": "例 \"dEj875ghj9273;eR\"",
	"step password submit": "確認",
	"step password show": "パスワードを表示",
	"step password hide": "パスワードを非表示",
	"step password description": "パスワードは、できるだけ複雑にする必要があります。悪意のある人々が、あなたのクラウドにアクセスするのを防ぐことができます。大文字、数字、特殊文字を使用することは必須です。",
	"step password server error": "何か問題があります。パスワードは保存されていません。",
	"step infos title": "Cozy を完成させます",
	"step infos description": "Cozy をセットアップするために、いくつかの情報が必要です。",
	"step infos public_name label": "ユーザー名",
	"step infos public_name placeholder": "Cozy があなたと話すために使用する公開の表示名。",
	"step infos email label": "メール",
	"step infos email placeholder": "パスワードをリセットするために Cozy が使用します。",
	"step infos timezone label": "タイムゾーン",
	"step infos timezone placeholder": "カレンダーを正しく表示するためにタイムゾーンが役立ちます。",
	"step infos submit": "確認",
	"step infos fetch data error": "サーバーからデータを取得できません。",
	"missing public_name": "ユーザー名を入力する必要があります。",
	"missing email": "メールを入力する必要があります。",
	"invalid email format": "メールアドレスが正しくないようです。",
	"missing timezone": "タイムゾーンを選択する必要があります",
	"invalid timezone": "タイムゾーンが正しくないようです。",
	"step accounts title": "Cozy を正常に作成しました!",
	"step accounts description line 1": "さあ、あなたが Cozy のサービスに接続するお供をします。",
	"step accounts description line 2": "最後に、Cozy の目標は、あなたのデータを取り戻す手助けをすることです!",
	"step accounts next": "参照",
	"myaccounts info": "'続行' をクリックして、いつでも Cozy にアクセスできます",
	"myaccounts next": "続行",
	"step confirmation title": "あなたのパーソナルクラウドへようこそ!",
	"step confirmation description line 1": "Cozy の準備ができました。",
	"step confirmation description line 2": "多くのサービスからデータを取り戻し、私たちのストアから必要なアプリケーションをインストールすることができます。",
	"step confirmation next": "進む",
	"step server error": "進行状況の保存中にエラーが発生しました。問題を修正するためにページを再読み込みする必要があります。",
	"preset name tip": "人とファイルを共有したり、イベントに招待するときに表示されます。",
	"preset password": "パスワード",
	"preset password tip": "8 文字以上の強いパスワードが必要です (特殊文字を推奨)。",
	"preset timezone": "タイムゾーン",
	"preset timezone tip": "カレンダーのイベントを正しく表示するために、タイムゾーンが必要です。",
	"preset opt-in help": "製品を改善するために、Cozy が私の使用状況を使用することを許可します。",
	"preset opt-out newsletter": "ベータ Cozy ニュースレターを購読します (強く推奨)。",
	"import from google": "私の Google アカウントからデータをインポート",
	"import google account": "Google から Gmail アカウントを同期して、カレンダー、連絡先、写真をインポートします",
	"import google account tip": "Cozy が Google でホストされているデータにアクセスできるようにするため、Google アカウントにログインする必要があります",
	"leave google title": "Cozy にデータをフィード",
	"leave google help me": "何をすべきかわかりません。助けてください!",
	"leave google sign in content": "Google アカウントにサインインして、Cozy がアクセスすることを承認してください。複雑な文字列を取得します。クリップボードにコピーしてください。",
	"leave google sign in": "Google にサインイン",
	"leave google code content": "次に、ポップアップからこのフィールドにコードをコピー＆貼り付けします:",
	"leave google code": "Google コード",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Google のサーバーに保存されたデータで何をしたいかを選択してください:",
	"leave google choice sync gmail": "GMail - Cozy からメールにアクセス",
	"leave google choice contacts": "Google の連絡先を 1 回インポート",
	"leave google choice calendar": "Google カレンダーを 1 回インポート",
	"leave google choice photos": "Google フォトを 1 回インポート",
	"leave google confirm": "データのインポート",
	"import error": "データをインポートしようとしたときにエラーが発生しました。専用アプリから後でもう一度試してください。",
	"login welcome user": "%{username} さん、ようこそ",
	"login welcome anon": "ようこそ",
	"login enter your password": "Cozy にアクセスするパスワードを入力してください",
	"login password": "パスワード",
	"login otp": "認証コード",
	"login submit": "ログイン",
	"login auth success": "正常に認証しました。始めましょう!",
	"login recover": "パスワードをお忘れですか? 変更するためメールで送信してください",
	"login recover busy": "説明を含むメールを送信しています",
	"login recover sent title": "メールを送信しました",
	"login recover sent message": "メールを確認してください。パスワードをリセットするための説明に従ってください。",
	"login recover error title": "メールの送信時にエラー",
	"login recover error message": "パスワード回復メッセージの送信中にエラー。MTA (メールサーバー) が実行しているか確認してください、またはサーバー管理者に連絡してください",
	"login wrong password title": "資格情報が間違っています",
	"login wrong password message": "入力した資格情報が間違っています。もう一度やり直してください。",
	"login server error": "エラーが発生しました。もう一度やり直してください。",
	"reset password request success title": "メールを送信しました",
	"reset password request success message": "メールを確認し、説明に従って、パスワードを変更してください。",
	"reset password request error": "エラーが発生しました。メールは送信されていません。 もう一度やり直してください。 エラーが続く場合は contact@cozycloud.cc までご連絡ください。",
	"reset welcome user": "パスワードを変更",
	"reset enter your password": "%{username} さん、Cozy のアクセスを回復するため、新しいパスワードを設定してください。",
	"reset password": "パスワード",
	"reset submit": "パスワードをリセット",
	"reset auth success": "パスワードを正常にリセットしました",
	"reset wrong password title": "パスワードをリセットできません",
	"reset wrong password message": "入力したパスワードが間違っているか、リセットトークンの有効期限が切れています",
	"reset password error invalid key": "パスワードリクエストの有効期限が切れています。 新しいものをリクエストしてください。",
	"reset password error password too weak": "パスワードの安全度が低すぎます。大文字、数字、特殊文字を追加したり、より長いパスワードにする必要があります。",
	"setup title": "Cozy をセットアップしています…",
	"setup message": "データが格納される、あなた自身のパーソナルクラウドに近づきました。",
	"setup on mobile title": "お使いの Android デバイスとデータを同期しましょう!",
	"setup on mobile message": "Google Play で私たちのモバイルアプリをチェックしてください:",
	"welcome title": "あなたの個人データをコントロールできるようになりました。おめでとうございます!",
	"welcome message": "あなた自身のパーソナルクラウド上にデータを保存することができるようになりました。ほとんどのクラウドサービスとは対照的に、Cozy ではデータマイニングは行われません。"
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/ja.json
// module id = 43
// module chunks = 0